import {
  COMMERCE_DELIVERY_RADIUS_KM_MIN,
  COMMERCE_DELIVERY_RADIUS_UI_KM_MAX,
} from '../../../../services/commerceService.ts';

export const RADIUS_KM_DEFAULT = 50;

export const ZONE_INFLUENCE_PRESET_KM = [5, 10, 25, 50, 100] as const;

export const RADIUS_SLIDER_STEPS = 1000;

export function clampRadiusKm(km: number) {
  return Math.min(
    COMMERCE_DELIVERY_RADIUS_UI_KM_MAX,
    Math.max(COMMERCE_DELIVERY_RADIUS_KM_MIN, Math.round(km))
  );
}

export function sliderPositionFromKm(km: number) {
  const c = clampRadiusKm(km);
  const range = COMMERCE_DELIVERY_RADIUS_UI_KM_MAX - COMMERCE_DELIVERY_RADIUS_KM_MIN;
  if (range <= 0) return 0;
  const t = (c - COMMERCE_DELIVERY_RADIUS_KM_MIN) / range;
  return Math.min(
    RADIUS_SLIDER_STEPS,
    Math.max(0, Math.round(RADIUS_SLIDER_STEPS * Math.sqrt(Math.max(0, Math.min(1, t)))))
  );
}

export function kmFromSliderPosition(pos: number) {
  const range = COMMERCE_DELIVERY_RADIUS_UI_KM_MAX - COMMERCE_DELIVERY_RADIUS_KM_MIN;
  const t = Math.min(1, Math.max(0, pos / RADIUS_SLIDER_STEPS));
  return clampRadiusKm(COMMERCE_DELIVERY_RADIUS_KM_MIN + range * t * t);
}
